<div class="row mb-3">
    <div class="col-md-8">
        <h3>{{pageTitle}}</h3>
    </div>
    <div class="col-md-4">
        <span class="float-right ml-auto">
            <button class="btn btn-default" type="button" (click)="goToBannerList();">
                View Banner List
            </button>
        </span>
    </div>
</div>
<div class="add-banner-page">
    <div class="row">
        <div class="col-md-12 mt-2">
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
                <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                    <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                    {{ alert.msg }}
                </div>
            </div>
        </div>
    </div>
    <div [ngStyle]="{'opacity': mode === 'view' ? '0.7':'1'}" class="mb-4">
        <form [formGroup]="bannerForm" (ngSubmit)="bannerForm.valid && onSave(bannerForm);" novalidate>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <mat-form-field appearance="outline" class="col-12 p-0">
                            <mat-label>Banner Title :</mat-label>
                            <input matInput placeholder="Banner Title" formControlName="title" required>
                        </mat-form-field>
                        <mat-error *ngIf="hasError('title', 'required')">Banner Title is required</mat-error>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <mat-form-field appearance="outline">
                            <mat-label>Banner Category :</mat-label>
                            <mat-select class="example-select-option" formControlName="category">
                                <mat-option value="">None</mat-option>
                                <mat-option *ngFor="let categoryObj of categoryTypes" [value]="categoryObj.value">
                                    {{categoryObj.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12">
                    <mat-label>Content Type :</mat-label>
                    <mat-button-toggle-group class="toggle-group" formControlName="contentType" aria-label="Font Style">
                        <mat-button-toggle *ngFor="let obj of contentTypes" [value]="obj.value">{{obj.name}}</mat-button-toggle>
                    </mat-button-toggle-group>
                    <mat-error *ngIf="hasError('contentType', 'required')">Content Type is required</mat-error>
                </div>
            </div>
            
            <div class="row mt-2">
                <div class="col-12">
                    <mat-label class="mr-2">Banner  Type :</mat-label>
                    <mat-button-toggle-group class="toggle-group " formControlName="bannerType" aria-label="Font Style">
                        <mat-button-toggle *ngFor="let obj of bannerTypes" [value]="obj.value">{{obj.name}}</mat-button-toggle>
                    </mat-button-toggle-group>
                    <mat-error *ngIf="hasError('bannerType', 'required')">Banner Type is required</mat-error>
                </div>
            </div>

            <div class="row mt-4">
                <div class="col-6">
                    <div class="form-group mt-1" [ngClass]="{'disabled':isViewMode}" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
                            <mat-form-field appearance="outline" class="col-12 p-0">
                                <mat-label>Banner Text :</mat-label>
                                <textarea id="autosize-textarea" (keyup)="autoSizeTextArea($event)" maxlength="500" [disabled]="isViewMode" matInput formControlName="content" placeholder="Enter Banner Text" [required]="true"> </textarea>
                            </mat-form-field>
                            <mat-error *ngIf="hasError('content', 'required')">Banner Text is required</mat-error>
                    </div>
                    <mat-error *ngIf="hasError('content', 'required')">Banner Text is required</mat-error>
                </div>
            </div>

        </form>

    </div>

    <div class="row" style="margin-top: 30px;">
        <div class="col-12 action-controls">
            <span *ngIf="mode==='view'">
                <button class="btn btn-default" (click)="onEdit()">Edit</button>
            </span>
            <span *ngIf="mode!=='view'">
                <button class="btn btn-default" (click)="onSave(bannerForm)">Save</button>
            </span>
            <span *ngIf="mode!=='view'" class="ml-2">
                <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
            </span>
        </div>
    </div>

</div>